<template>
  <div class="add-cart-popup" v-if="product_res && show_onOff">
    <div class="PageOverlay" @click="show_onOff = false"></div>
    <div class="add-cart-popup-content">
      <div
        class="iconfont icon-cancel-1-copy"
        @click="show_onOff = false"
      ></div>
      <div class="add-cart-popup-content-head">
        <div class="acpc-head-left">
          <img
            :src="
              (mix_now_image_data && mix_now_image_data.url) ||
              defaultImage
            "
            alt=""
          />
        </div>
        <div class="acpc-head-right">
          <h5 class="text-overflow-2">
            {{ goodSellConfig ? goodSellConfig.title : product_res.post_title || product_res.title }}
          </h5>
          <h6 class="text-overflow-2">
            {{ goodSellConfig ? goodSellConfig.sub_title : product_res.subtitle }}
          </h6>
          <div>
            <v-simplePrice
              mode="regular_price"
              v-if="computed_price.price < computed_price.regular_price"
              :price="computed_price.regular_price"
            ></v-simplePrice>
            <v-simplePrice :price="computed_price.price"></v-simplePrice>
          </div>
        </div>
      </div>
      <div class="add-cart-popup-content-main">
        <v-combination-card
          v-if="$store.state.combination_list[product.ID]"
          :combinations="$store.state.combination_list[product.ID]"
          :theme="theme"
          :productDetail.sync="product"
        ></v-combination-card>
        <div
          class="acpc-main-attr"
          v-if="product_res && product_res.variant_attrs"
        >
          <!-- 普通属性和特殊属性分开布局,经过特殊处理的属性都会有special_native_name字段，根据special_native_name字段判断当前属性是否特殊属性 -->
          <div class="acpc-main-attr--normal">
            <template v-for="(item, index) in product_res.variant_attrs">
              <div :key="item.name + index" v-if="!item.special_native_name">
                <div class="text-overflow-1">{{ item.name }} :</div>
                <v-labelStyle
                  :attrs="item"
                  :index="index"
                  :variant_attrs="variant"
                  :key_name="
                    uniqueKey(['athenaGroupedProduct', product_res.ID])
                  "
                  lable_active="main_button"
                  theme="athena"
                ></v-labelStyle>
              </div>
            </template>
          </div>
          <!-- 有特殊属性时候布局 -->
          <div class="acpc-main-attr--special" v-if="has_special_attrs">
            <div class="text-overflow-1">Select Prescription ：</div>
            <template v-for="(item, index) in product_res.variant_attrs">
              <div :key="item.name + index" v-if="item.special_native_name">
                <v-selectStyle
                  @click.native="follow_main_variant_list = false"
                  :variant_attrs="variant"
                  :index="index"
                  :key_name="uniqueKey(['mobileAddCartPopup', product_res.ID])"
                  :attrs="item"
                  theme="athena"
                  :show_dropdown="true"
                ></v-selectStyle>
              </div>
            </template>
          </div>
          <div class="acpc-main-attr--qty">
            <label for="count" class="label" style="margin: 0">
              {{$t('detail.quantity')}}:
            </label>
            <v-inputnum
              mode="notBoder"
              v-model="add_cart_data.quantity"
              :min="1"
              :step="1"
            ></v-inputnum>
          </div>
        </div>
      </div>
      <div class="add-cart-popup-content-foot">
        <div class="acpc-foot-btn">
          <button @click="goodSellConfig?add_cart('buynow'):add_cart()" v-if="computed_price.buy_able">
            {{ goodSellConfig ? goodSellConfig.btn_text || 'BUY IT NOW' : $t('comment.confirm')}}
          </button>
          <button v-else class="soldout cursor-default">
            <span class="text-uppercase add"> {{ $t("detail.sold_out") }}</span>
          </button>
        </div>
        <div class="acpc-foot-link" v-if="goodSellConfig">
             <span>Secured And Encrypted</span>
        </div>
        <div class="acpc-foot-link" v-else-if="product.path">
          <a :href="product.path"> {{$t('add.see_item_details')}} </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import mixAdd from "@/js/mixins/mixAdd";
import mixProduct from "@/js/mixins/mixProduct";
import vSelectStyle from "@/views/venue/js/view/product/selectStyle.vue";
import vLabelStyle from "@/views/venue/js/view/product/labelStyle.vue";
import vCombinationCard from "@/js/components/view/combinations/combinationCard.vue";
import vInputnum from "@/views/venue/js/common/inputnum.vue";

export default {
  data() {
    return {
      show_onOff: false,
      product: null,
      goodSellConfig: null, // 当这个参数存在时，会替换配置中的标题，副标题和按钮文字
      addType:'dialog',
    };
  },
  mixins: [mixProduct, mixAdd],
  computed: mapState({
    cart_type: (state) => state.options?.theme?.global?.cart?.type,
    theme: "theme_name",
  }),
  methods: {
    show(product = {},goodSellConfig) {
      this.show_onOff = true;
      this.product = product;
      if(goodSellConfig) {
        this.goodSellConfig = goodSellConfig;
      }
      else {
        this.goodSellConfig = null;
      }
    },
  },
  mounted() {
    this.$on("mixAddCartCallBack", () => {
      this.show_onOff = false;
    });
    Vue.prototype.showMobileAddCartPopup = this.show;
  },
  components: {
    vSelectStyle,
    vLabelStyle,
    vCombinationCard,
    vInputnum
  },
};
</script>
<style scoped lang='scss'>
.add-cart-popup {
  position: fixed;
  z-index: 9999999999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .PageOverlay {
    visibility: visible;
    opacity: 1;
    background-color: rgba($color: #000000, $alpha: 0.4);
    z-index: 100;
  }
  &-content {
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 101;
    width: 100%;
    padding: 15px;
    background-color: #ffffff;
    .iconfont.icon-cancel-1-copy {
      position: absolute;
      top: 15px;
      right: 15px;
      color: #838793;
      font-size: 12px;
      font-weight: 600;
    }
    &-head {
      display: flex;
      padding-bottom: 15px;
      border-bottom: 1px solid #dedede;
      .acpc-head-left {
        margin-right: 15px;
        width: 70px;
        min-width: 70px;
        max-width: 70px;
        height: 70px;
        background-color: #ececec;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .acpc-head-right {
        h5 {
          line-height: 18px;
          font-size: 13px;
          font-family: Roboto-Medium;
          color: #222222;
          font-weight: 500;
        }
        h6 {
          margin-top: 7px;
          line-height: 1;
          font-size: 12px;
          font-family: Roboto-Medium;
          color: #888888;
          -webkit-line-clamp: 1;
        }
        div {
          margin-top: 8px;
          font-size: 13px;
          font-family: Roboto;
          font-weight: 400;
          color: #999999;
        }
      }
    }
    &-main {
      max-height: 50vh;
      overflow-y: auto;
      &::-webkit-scrollbar {
      width: 0;
      height: 2px;
      opacity: 0;
      transition: opacity 120ms ease-out;
      &:hover {
        opacity: 1;
      }
      }
      &::-webkit-scrollbar-thumb {
        background-color: rgba(144, 147, 153, 0.3);
        transition: 0.3s background-color;
      }
      &::-webkit-scrollbar-track-piece {
        background-color: #fff;
      }
      .acpc-main-attr {
        &--normal {
          & > div {
            padding-top: 15px;
            border-bottom: 1px solid #dedede;
            .labelStyle {
              padding-top: 9px;
              padding-bottom: 8px;
            }
          }
        }
        &--special {
          display: flex;
          flex-wrap: wrap;
          padding-top: 15px;
          padding-bottom: 15px;
          border-bottom: 1px solid #dedede;
          .text-overflow-1 {
            width: 100%;
            padding-bottom: 15px;
          }
          & > div:not(.text-overflow-1) {
            flex: 1;
            padding-right: 15px;
            &::v-deep .select-style-box {
              select {
                margin-bottom: 0;
                height: 34px;
                line-height: 34px;
                padding: 0;
              }
            }
          }
          & > div:last-child {
            padding-right: 0;
          }
        }
        &--qty {
          & > label {
            display: block;
            width: 100%;
            padding-top: 15px;
          }
          &::v-deep .product_qty {
            padding-top: 15px;
            height: 49px;
          }
        }
      }
      &::v-deep .combine {
        .combine_items {
          .combine_item {
            margin-right: 1px;
          }
        }
      }
    }
    &-foot {
      margin-top: 40px;
      .acpc-foot-btn {
        button {
          width: 100%;
          height: 40px;
          line-height: 40px;
          background-color: #1f2537;
          text-align: center;
          color: #ffffff;
          font-size: 14px;
        }
      }
      .acpc-foot-link {
        margin-top: 15px;
        text-align: center;
        a {
          font-size: 12px;
          font-family: Roboto;
          font-weight: 400;
          text-decoration: underline;
          color: #1f2537;
        }
        span {
          &::before {
          content: '\e608';
          font-family: 'iconfont';
          color: #3FC6AD;
          margin-right: 5px;
        }
        };
      }
    }
  }
}
</style>